// modules
import {
  MatButtonModule,
  MatInputModule,
  MatIconModule,
  MatTabsModule,
  MatDialogModule,
  MatProgressSpinnerModule,
  MatSliderModule,
  MatFormFieldModule,
  MatSelectModule,
  MatRadioModule,
  MatCheckboxModule,
  MatSlideToggleModule
} from '@angular/material';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppRoutingModule } from './app-routing.module';

// services
import { PreviewService } from './services/preview.service';
import { GAService } from './services/ga.service';
import { MapService } from './services/map.service';
import { GoogleMapsService } from './services/google-maps.service';
import { StyleService } from './services/style.service';
import { PrintService } from './services/print.service';

// components
import { AppComponent } from './app.component';
import { EditorComponent } from './components/editor/editor.component';
import { MapComponent } from './components/map/map.component';
import { MapConfiguratorComponent } from './components/map-configurator/map-configurator.component';
import { RequestPreviewDialogComponent } from './components/request-preview-dialog/request-preview-dialog.component';
import { MapSizeComponent } from './components/map-size/map-size.component';
import { MapContainerComponent } from './components/map-container/map-container.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { AccordionItemComponent } from './components/accordion/accordion-item.component';
import { MapConfigLocationComponent } from './components/map-config-location/map-config-location.component';
import { MapConfigStyleComponent } from './components/map-config-style/map-config-style.component';
import { MapConfigSizeComponent } from './components/map-config-size/map-config-size.component';
import { MapConfigLabelsComponent } from './components/map-config-labels/map-config-labels.component';
import { MapConfigFrameComponent } from './components/map-config-frame/map-config-frame.component';
import { MapConfigOffersComponent } from './components/map-config-offers/map-config-offers.component';
import { MapConfigIconsComponent } from './components/map-config-icons/map-config-icons.component';

// others
import { MapToIterablePipe } from './pipes/map-to-iterable.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { DecimalPipe, CurrencyPipe, registerLocaleData } from '@angular/common';
import { AppErrorHandler } from './app.error-handler';
import { UnitOfLengthAbbrPipe } from './pipes/unit-of-length-abbr.pipe';
import { SettingsDialogComponent } from './components/settings-dialog/settings-dialog.component';
import { OffersDialogComponent } from './components/offers-dialog/offers-dialog.component';
import { SettingsToggleComponent } from './components/settings-toggle/settings-toggle.component';
import { LoadingComponent } from './components/loading/loading.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SettingsService } from './services/settings.service';
import { MapifyPricePipe } from './pipes/mapify-price.pipe';

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// locales
import localeDe from '@angular/common/locales/de';
registerLocaleData(localeDe, 'de');

import localeEs from '@angular/common/locales/es';
import { UtilsService } from './services/utils.service';
registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent,
    EditorComponent,
    MapComponent,
    MapConfiguratorComponent,
    RequestPreviewDialogComponent,
    MapSizeComponent,
    MapContainerComponent,
    AccordionComponent,
    AccordionItemComponent,
    MapConfigLocationComponent,
    MapConfigStyleComponent,
    MapConfigSizeComponent,
    MapConfigLabelsComponent,
    MapConfigFrameComponent,
    MapConfigOffersComponent,
    MapConfigIconsComponent,
    MapToIterablePipe,
    KeysPipe,
    UnitOfLengthAbbrPipe,
    SettingsDialogComponent,
    OffersDialogComponent,
    SettingsToggleComponent,
    LoadingComponent,
    MapifyPricePipe
  ],
  entryComponents: [RequestPreviewDialogComponent, SettingsDialogComponent, OffersDialogComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatCheckboxModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    PreviewService,
    GAService,
    GoogleMapsService,
    DecimalPipe,
    CurrencyPipe,
    StyleService,
    MapService,
    PrintService,
    UnitOfLengthAbbrPipe,
    SettingsService,
    MapifyPricePipe,
    UtilsService,
    { provide: ErrorHandler, useClass: AppErrorHandler },
    {
      provide: LOCALE_ID,
      deps: [SettingsService],
      useFactory: settingsService => settingsService.getLocale()
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/app.module.ts